import {Router, Route, IndexRoute, Redirect} from 'react-router';
import ScheduleLobby from 'Schedule/views/ScheduleLobby';
import LocalHistory from 'LocalHistory';
import SbsSuite from 'SbsSuite';
import ProcessOutcomeUpdateCreate from 'ProcessOutcomeUpdateCreate/Presentation/ProcessOutcomeUpdateCreate';
import Navigation from 'Navigation';
import Login from 'Login';
import Admin from 'Admin';
import Authentication from 'Authentication';
import ConsumableLobby from 'Consumables/views/ConsumableLobby';
import Theme from 'Theme';
import UpdateCreateSbsView from 'Sbs/views/UpdateCreateSbsView';
import TeamCreateView from 'Teams/views/TeamCreateView';
import SbsLobbyView from 'SbsLobby/Views/SbsLobbyView';
import CreateUpdateScheduleView from 'Schedule/views/CreateUpdateScheduleView';
import ScheduleView from 'Schedule/views/ScheduleView';

function requireAuth(nextState, replace) {
  if (!Authentication.isLoggedIn()) {
    replace({
      pathname: '/login',
      state: {
        nextPathname: nextState.location.pathname,
      },
    });
  }
}

const routes = (
  <Route>
    <Route path="login" component={Login} />
    <Route component={Navigation} onEnter={requireAuth}>
      <Route path="Teams">
        <IndexRoute component={TeamCreateView} />
        <Route path="create" component={TeamCreateView} />
      </Route>

      <Route path="Sbss">
        <IndexRoute component={SbsLobbyView} />
        <Route path="create" component={UpdateCreateSbsView} />
        <Route path=":sbsId" component={SbsSuite} />
        <Route path=":sbsId/update" component={UpdateCreateSbsView} />
        <Route
          path=":sbsId/processOutcomes/create"
          component={ProcessOutcomeUpdateCreate}
        />
        <Route
          path=":sbsId/processOutcomes/:processOutcomeId/update"
          component={ProcessOutcomeUpdateCreate}
        />
      </Route>

      <Route path="Schedules">
        <IndexRoute component={ScheduleLobby} />
        <Route path="" component={ScheduleLobby} />
        <Route path="create" component={CreateUpdateScheduleView} />
        <Route path=":scheduleId/update" component={CreateUpdateScheduleView} />
        <Route path=":scheduleId/scheduleSteps" component={ScheduleView} />
      </Route>

      <Route path="Consumables">
        <IndexRoute component={ConsumableLobby} />
        <Route path="" component={ConsumableLobby} />
      </Route>

      <Route path="Admin">
        <IndexRoute component={Admin} />
        <Route path="Permissions" component={Admin} />
      </Route>

      <Redirect from="*" to="/Sbss" />
    </Route>
  </Route>
);
const RouterExport = () => (
  <Theme>
    <Router history={LocalHistory} routes={routes} />
  </Theme>
);

export default RouterExport;
